import { Component, computed, EventEmitter, Input, Output, signal } from '@angular/core';
import { expandCollapse } from 'src/app/_shared/animations/expand-collapse.animation';
import { ExperienceLink, ExperienceModel } from 'src/app/models/experience-link';

@Component({
  selector: 'info-link',
  templateUrl: './info-link.component.html',
  styleUrls: ['./info-link.component.scss'],
  animations: [expandCollapse]
})
export class InfoLinkComponent {
  @Input()
  link: ExperienceModel;

  @Output()
  experienceLinkSelected = new EventEmitter<ExperienceLink>();

  readonly MAX_SIZE_EXPERIENCES = 4;
  readonly expanded = signal<boolean>(false);
  readonly expandedLabel = computed(() => this.expanded() ? 'common.viewLess' : 'common.viewMore');
}
